import { enableProdMode, importProvidersFrom } from '@angular/core';

import { DatePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
  DateAdapter,
  MatNativeDateModule,
  MatRippleModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { CustomerMasterPageRoutingModule } from './app/customer-master-page/customer-master-page-routing.module';
import { DateFormat } from './app/date-format';
import { DealersManagementRoutingModule } from './app/dealers-management/dealers-management-routing.module';
import { DealersOtaPageRoutingModule } from './app/dealers-ota-page/dealers-ota-page-routing.module';
import { DeviceDashboardPageRoutingModule } from './app/device-dashboard-page/device-dashboard-page-routing.module';
import { DeviceDetailsPageRoutingModule } from './app/device-details-page/device-details-page-routing.module';
import { DispatchDeviceAddPageRoutingModule } from './app/dispatch-device-add-page/dispatch-device-add-page-routing.module';
import { DispatchDevicePageRoutingModule1 } from './app/dispatch-device-page/dispatch-device-page-routing.module';
import { DispatchDevicePageRoutingModule } from './app/dispatch-device/dispatch-device-routing.module';
import { FirmwareMasterRoutingModule } from './app/firmware-master/firmware-master-routing.module';
import { FotaBatchDetailsPageRoutingModule } from './app/fota-batch-details-page/fota-batch-details-page-routing.module';
import { FotaBatchPageRoutingModule } from './app/fota-batch-page/fota-batch-page-routing.module';
import { GovtServersAddPageRoutingModule } from './app/govt-servers-add-page/govt-servers-add-page-routing.module';
import { GovtServersPageRoutingModule } from './app/govt-servers-page/govt-servers-page-routing.module';
import { HttpTokenInterceptorService } from './app/http-token-interceptor.service';
import { LoginPageRoutingModule } from './app/login-page/login-page-routing.module';
import { ModelFirmwarePageRoutingModule } from './app/model-firmware-page/model-firmware-page-routing.module';
import { ModelPageRoutingModule } from './app/model-page/model-page-routing.module';
import { OtaBatchCreateRoutingModule } from './app/ota-batch-create/ota-batch-create-routing.module';
import { OtaBatchDetailsRoutingModule } from './app/ota-batch-details/ota-batch-details-routing.module';
import { OtaBatchPageRoutingModule } from './app/ota-batch-page/ota-batch-page-routing.module';
import { OtaMasterRoutingModule } from './app/ota-master/ota-master-routing.module';
import { ProductionDeviceAddPageRoutingModule } from './app/production-device-add-page/production-device-add-page-routing.module';
import { ProductionDevicePageRoutingModule1 } from './app/production-device-page/production-device-page-routing.module';
import { ProductionDevicePageRoutingModule } from './app/production-device/production-device-routing.module';
import { ProfilePageRoutingModule } from './app/profile-page/profile-page-routing.module';
import { RolesGroupPageRoutingModule } from './app/roles-group-page/roles-group-page-routing.module';
import { SamparkEolDeviceAddPageRoutingModule } from './app/sampark-eol-device-add-page/sampark-eol-device-add-page-routing.module';
import { SamparkEolPageRoutingModule } from './app/sampark-eol-page/sampark-eol-page-routing.module';
import { SensoriseSimDataPageRoutingModule } from './app/sensorise-sim-data-details/sensorise-sim-data-details-routing.module';
import { UserRolePageRoutingModule } from './app/user-role-page/user-role-page-routing.module';
import { UserTabPageRoutingModule } from './app/user-tab-page/user-tab-page-routing.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      // routing moduel import
      DeviceDashboardPageRoutingModule,
      LoginPageRoutingModule,
      DeviceDetailsPageRoutingModule,
      FotaBatchDetailsPageRoutingModule,
      DispatchDevicePageRoutingModule,
      DispatchDevicePageRoutingModule1,
      DispatchDeviceAddPageRoutingModule,
      ProductionDevicePageRoutingModule,
      ProductionDevicePageRoutingModule1,
      ProductionDeviceAddPageRoutingModule,
      SamparkEolPageRoutingModule,
      SamparkEolDeviceAddPageRoutingModule,
      // DeviceFotaRoutingModule,
      FotaBatchPageRoutingModule,
      // DeviceFotaDetailsRoutingModule,
      OtaBatchCreateRoutingModule,
      OtaBatchDetailsRoutingModule,
      OtaBatchPageRoutingModule,
      GovtServersPageRoutingModule,
      ModelPageRoutingModule,
      CustomerMasterPageRoutingModule,
      ModelFirmwarePageRoutingModule,
      // MyActivationsPageRoutingModule,
      UserTabPageRoutingModule,
      UserRolePageRoutingModule,
      // UserPermissionsPageRoutingModule,
      ProfilePageRoutingModule,
      GovtServersAddPageRoutingModule,
      DispatchDevicePageRoutingModule,
      DispatchDevicePageRoutingModule1,
      RolesGroupPageRoutingModule,
      FirmwareMasterRoutingModule,
      DealersManagementRoutingModule,
      DealersOtaPageRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      MatTabsModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatCheckboxModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatNativeDateModule,
      MatExpansionModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatNativeDateModule,
      MatPaginatorModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatRippleModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatSortModule,
      MatStepperModule,
      MatTableModule,
      MatTabsModule,
      MatToolbarModule,
      MatTooltipModule,
      NgxPaginationModule,
      MatFormFieldModule,
      NgxSpinnerModule,
      RouterModule,
      OtaMasterRoutingModule,
      SensoriseSimDataPageRoutingModule
    ),
    { provide: DateAdapter, useClass: DateFormat },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptorService,
      multi: true,
    },
    DatePipe,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
  ],
}).catch((err) => console.error(err));
